/**
 * Colors baked into the copy-paste embed snippets.
 *
 * WHY these are legitimate fixed values: the snippet renders on the CUSTOMER's
 * site, where the Ishvaram token layer does not exist, so semantic tokens
 * genuinely cannot own them. They are customer-facing generated output data,
 * not UI styling, and must stay byte-stable regardless of our theme (reading
 * them from getComputedStyle would leak the viewer's theme into every
 * customer's generated embed code).
 *
 * They are honest hex because that is what they are. The exemption that makes
 * them legal is declared in policy — `sanctioned_literals` in
 * data/governance/web_design_system_adoption.yaml, scoped to this exact path
 * and to `raw_hex_color` alone — not encoded past the scanner. Issue #1558:
 * these were previously held as numeric literals purely to keep the raw-hex
 * scan clean, which is obfuscation-as-compliance and must never be the house
 * pattern. Any other governed literal follows the same route: name it in the
 * policy with a reason, or migrate it to a semantic token.
 */

/** iframe border in the generated snippet (historically the slate-200 value). */
export const EMBED_FRAME_BORDER = "#e2e8f0";

/** attribution line + link color in the generated snippet (slate-500 value). */
export const EMBED_ATTRIBUTION_COLOR = "#64748b";
